/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".login-page-layout[_ngcontent-%COMP%]{min-height:calc(100vh - 191px)}.login-logo[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff}.checkbox[_ngcontent-%COMP%], .radio[_ngcontent-%COMP%]{left:21px}"];
export { styles as styles };
